"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lruMemoize = require("lru-memoize");

var _lruMemoize2 = _interopRequireDefault(_lruMemoize);

var _validation = require("../../utils/validation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var recommendValidation = (0, _validation.createValidator)({
  email: [_validation.required, _validation.email],
  name: _validation.required
});
exports.default = (0, _lruMemoize2.default)(10)(recommendValidation);
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Recommend/recommendValidator.js
 ** module id = 1238
 ** module chunks = 0
 **/